import { executeRequest, Request } from '@jfs/network'
import { Api } from '../data/models/Api'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const apisListParser = (data: any, profileName: string): any[] => {
  const apisList = data?.map((apiData: any) =>
    Api.create({
      id: `${apiData?.apiId}`,
      apiId: `${apiData?.apiId}`,
      appName: apiData?.appName ?? 'NA',
      status: apiData?.status,
      channelId: apiData?.channelId,
      apiEndPoint: apiData?.apiEndPoint ?? 'NA',
      exposedTo: apiData?.exposedTo,
      filterType: apiData?.filterType,
      apigwEndPoint: apiData?.apigwEndPoint ?? 'NA',
      isActive: apiData?.isActive ?? false,
      isSelected: apiData?.isActive ?? false,
      profileName: profileName ?? '',
    }),
  )
  return apisList
}

const responseParser = (data: any, profileName: string) => {
  if (data?.error) {
    RootStore.response.setMessage(data?.error?.message)
    return
  }
  const respData = apisListParser(data.data.data, profileName)
  return respData
}

const fetchApiMappingListOfChannelIdReq = (channelId: string, profileName: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.getApiMappingList,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      channelId: channelId,
      responseType: 'DEFAULT',
    },
    responseType: 'text',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data, profileName)
  })
}

export { fetchApiMappingListOfChannelIdReq }
